<script lang="ts" setup>
import type { Data } from '~~/server/api/documents/index'

export interface PagesDocumentsCategoriesProps {
    data: Data
}

const props = defineProps<PagesDocumentsCategoriesProps>()
const router = useRouter()
const { $t } = useNuxtApp()

const title = $t('Kategória:')

const categoryGroupTitleId = useId()

const handleClick = (value: string): void => {
    router.push({
        query: {
            td: props.data.category_level_0.slug,
            k: value,
        },
    })
}
</script>
<template>
  <section
    v-if="props.data.categories"
    data-cy="pages_documents_categories"
    :aria-labelledby="categoryGroupTitleId"
  >
    <Tracker :data="{ position: title }">
      <p
        :id="categoryGroupTitleId"
        class="zeta mb-2 mb-md-4 fw-bold"
      >
        {{ title }}
      </p>
      <ul
        class="d-flex gap-2 flex-wrap"
        role="list"
        :aria-label="$t('Filtrovať podľa kategórie')"
      >
        <li
          v-for="(category, index) in props.data.categories"
          :key="`dsubc-${index}`"
        >
          <VButton
            color="tertiary"
            :class="[
              {
                'is-active':
                  props.data.category_level_1?.slug ===
                  category.slug,
              },
              'text-truncate',
            ]"
            type="button"
            :label="category.title"
            :aria-pressed="props.data.category_level_1?.slug === category.slug"
            @click.prevent="handleClick(category.slug)"
          >
            {{ category.title }}
          </VButton>
        </li>
      </ul>
    </Tracker>
  </section>
</template>
